import * as React from 'react';
import { ListItem } from './common/List';
import { Flex } from '@workday/canvas-kit-react/layout';
import { createComponent } from '@workday/canvas-kit-react/common';
import { PaginationContext } from './usePaginationModel';
export const PageList = createComponent('ol')({
    displayName: 'Pagination.PageList',
    Component({ children, ...elemProps }, ref, Element) {
        const model = React.useContext(PaginationContext);
        return (React.createElement(Flex, Object.assign({ ref: ref, as: Element, margin: "zero", role: "list", paddingLeft: "zero", paddingRight: "zero", gap: "xxxs" }, elemProps), typeof children === 'function' ? children(model) : children));
    },
});
export const PageListItem = createComponent('li')({
    displayName: 'Pagination.PageListItem',
    Component({ children, ...elemProps }, ref, Element) {
        return (React.createElement(ListItem, Object.assign({ ref: ref, as: Element }, elemProps), children));
    },
});
